import { QualityGroupProps } from 'components/Myself/components/QualityGroup/props';
import React from 'react';
import { connect } from 'react-redux';
import Waypoint from 'react-waypoint';

import getVisibleQualities from 'selectors/myself/getVisibleQualities';
import { IAppState } from 'types/app';

import QualityItem from '../QualityItem';

type OwnProps = Omit<QualityGroupProps, 'id'>;

export function QualityGroupComponent({
  filterString,
  name,
  onEnterWaypoint,
  qualities,
}: OwnProps & ReturnType<typeof mapStateToProps>) {
  if (!qualities.length) {
    return null;
  }

  return (
    <div
      className="quality-group"
      data-group-name={name}
    >
      <Waypoint onEnter={onEnterWaypoint}>
        <h2 className="heading heading--2 quality-group__name">{name}</h2>
      </Waypoint>
      <ul id="filter-list-1" className="js-filter-list items items--list quality-group__items">
        {qualities.map((q: any) => <QualityItem filterString={filterString} key={q.id} {...q} />)}
      </ul>
    </div>
  );
}

const mapStateToProps = (state: IAppState, props: OwnProps) => ({
  qualities: getVisibleQualities(state, props),
});

export default connect(mapStateToProps)(QualityGroupComponent);